import { render } from "./InstancesItem.vue?vue&type=template&id=161a251f&scoped=true"
import script from "./InstancesItem.vue?vue&type=script&lang=js"
export * from "./InstancesItem.vue?vue&type=script&lang=js"

import "./InstancesItem.vue?vue&type=style&index=0&id=161a251f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-161a251f"]])

export default __exports__